module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_0.2ee27d93.png";